export abstract class PositiveInteger {
  private _value: number

  constructor (value: number) {
    if (value < 1) {
      throw new TypeError()
    }
    this._value = value
  }

  value (): number {
    return this._value
  }
}
